import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ProductCollectionsPreviewRequestQuery
*  Query params for operation "ProductCollectionsPreview"
*/
export class ProductCollectionsPreviewRequestQuery extends ActiveModel {

  /**
  * collectionsLimit
  * Число подборок (по умолчанию 10, макс. 50)  */
  @ActiveField()
  collectionsLimit?: number


  /**
  * itemsLimit
  * Число карточек в каждой (по умолчанию 8, макс. 50)  */
  @ActiveField()
  itemsLimit?: number
}
